import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Paper, Select, TextField } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';

import { wsGetAll } from 'services/WService';

const useStyles = makeStyles((theme) => ({
  ...styles,
  paper: {
    padding: theme.spacing(2),
    marginBottom: '15px'
  }
}));

export default function Write(props) {
  const classes = useStyles();
  const { bPartner, handleChange } = props;

  const [docTypeInput, setDocTypeInput] = useState({});
  const changeDocument = (doc) => {
    setDocTypeInput(doc);
  };

  //#region listados
  const [documentTypes, setDocumentTypes] = useState([]);
  const [currencys, setCurrencys] = useState([]);
  const [personTypes, setPersonTypes] = useState([]);

  async function listDocumentType() {
    let response = await wsGetAll('base/document-type');
    if (response.success) {
      setDocumentTypes(response.data);
      setDocTypeInput(response.data.find((item) => item.id == (bPartner.CardType === 'C' ? 2 : 4)));
    }
  }

  async function listCurrency() {
    let response = await wsGetAll('base/currency');
    if (response.success) setCurrencys(response.data);
  }

  async function listPersonType() {
    let response = await wsGetAll('base/person-type');
    if (response.success) setPersonTypes(response.data);
  }
  //#endregion

  useEffect(() => {
    listDocumentType();
    listCurrency();
    listPersonType();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={4} style={{ marginBottom: '12px' }}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo Persona</InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu,
            }}
            value={bPartner.base_person_type_id || ''}
            inputProps={{
              name: 'base_person_type_id',
              onChange: handleChange,
            }}
          >
            {personTypes.map((personType, i) => {
              return (
                <MenuItem value={personType.id} key={i}>
                  {personType.description}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={4} style={{ marginBottom: '12px' }}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo Documento</InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu,
            }}
            value={bPartner.base_document_type_id || ''}
            inputProps={{
              name: 'base_document_type_id',
              onChange: handleChange,
            }}
          >
            {documentTypes.map((documentType, i) => {
              return (
                <MenuItem
                  value={documentType.id}
                  key={i}
                  onClick={() => changeDocument(documentType)}
                >
                  {documentType.description_short}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={4} style={{ marginBottom: '12px' }}>
        <TextField
          key={docTypeInput.id}
          label={docTypeInput.description_short}
          name="LicTradNum"
          value={bPartner.LicTradNum || ''}
          fullWidth
          margin="normal"
          size="small"
          inputProps={{
            onChange: handleChange,
            minLength: docTypeInput.validation || 8,
            maxLength: docTypeInput.validation || 15,
          }}
          onKeyPress={(e) => {
            var key = window.event ? e.which : e.keyCode;
            if (key < 48 || key > 57) {
              return e.preventDefault();
            }
          }}
        />
      </GridItem>

      <GridItem xs={12}>
        <GridContainer>
          {bPartner.U_SYP_BPTP == 'TPN' ? (
            <GridItem xs={12} sm={6} md={6} lg={4}>
              <Paper className={classes.paper}>
                <TextField
                  label="Primer Nombre"
                  name="U_SYP_BPNO"
                  value={bPartner.U_SYP_BPNO || ''}
                  fullWidth
                  margin="normal"
                  size="small"
                  inputProps={{ onChange: handleChange }}
                />
                <TextField
                  label="Segundo Nombre"
                  name="U_SYP_BPN2"
                  value={bPartner.U_SYP_BPN2 || ''}
                  fullWidth
                  margin="normal"
                  size="small"
                  inputProps={{ onChange: handleChange }}
                />
                <TextField
                  label="Apellido Paterno"
                  name="U_SYP_BPAP"
                  value={bPartner.U_SYP_BPAP || ''}
                  fullWidth
                  margin="normal"
                  size="small"
                  inputProps={{ onChange: handleChange }}
                />
                <TextField
                  label="Apellido Materno"
                  name="U_SYP_BPAM"
                  value={bPartner.U_SYP_BPAM || ''}
                  fullWidth
                  margin="normal"
                  size="small"
                  inputProps={{ onChange: handleChange }}
                />
                <TextField
                  label="Correo"
                  name="E_Mail"
                  value={bPartner.E_Mail || ''}
                  fullWidth
                  margin="normal"
                  size="small"
                  inputProps={{ onChange: handleChange }}
                />
                <TextField
                  label="Celular"
                  name="Cellular"
                  value={bPartner.Cellular || ''}
                  fullWidth
                  margin="normal"
                  size="small"
                  inputProps={{ onChange: handleChange }}
                />
                <TextField
                  label="Teléfono"
                  name="Phone1"
                  value={bPartner.Phone1 || ''}
                  fullWidth
                  margin="normal"
                  size="small"
                  inputProps={{ onChange: handleChange }}
                />
              </Paper>
            </GridItem>
          ) : (
            ''
          )}
          <GridItem xs={12} sm={6} md={6} lg={4}>
            <Paper className={classes.paper}>
              <TextField
                label="Código"
                disabled
                name="CardCode"
                value={bPartner.CardCode || ''}
                margin="normal"
                fullWidth
                size="small"
                inputProps={{ onChange: handleChange }}
              />
              <TextField
                label="Nombre Comercial"
                name="CardFName"
                margin="normal"
                size="small"
                inputProps={{ onChange: handleChange }}
                fullWidth
                value={bPartner.CardFName || ''}
              />
              <TextField
                label="Nombre Socio Negocio"
                name="CardName"
                margin="normal"
                size="small"
                inputProps={{ onChange: handleChange }}
                fullWidth
                value={bPartner.CardName || ''}
              />
              {bPartner.CardType === 'S' && (
                <TextField
                  label="Dirección"
                  name="Address"
                  value={bPartner.Address || ''}
                  fullWidth
                  margin="normal"
                  size="small"
                  inputProps={{ onChange: handleChange }}
                />
              )}
              {/* <TextField
                label="Código Socio Relacionado"
                name="CardCode_relationed"
                value={bPartner.CardCode_relationed || ''}
                fullWidth
                margin="normal"
                size="small"
                inputProps={{ onChange: handleChange }}
              /> */}

              <TextField
                label="Validación - Revisión"
                type="date"
                name="validated_at"
                value={bPartner.validated_at || ''}
                margin="normal"
                size="small"
                inputProps={{ onChange: handleChange }}
                fullWidth
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Socio es empleado</InputLabel>
                <Select
                  value={bPartner.QryGroup5 || ''}
                  inputProps={{
                    name: 'QryGroup5',
                    onChange: handleChange,
                  }}
                >
                  <MenuItem value="Y">Si</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
              </FormControl>

              {/* Data específica de proveedor */}
              {bPartner.CardType === 'C' ? (
                <>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Aplica interés en órdenes al crédito</InputLabel>
                    <Select
                      value={bPartner.QryGroup4 || ''}
                      inputProps={{
                        name: 'QryGroup4',
                        onChange: handleChange,
                      }}
                    >
                      <MenuItem value="Y">Si</MenuItem>
                      <MenuItem value="N">No</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Clientes varios</InputLabel>
                    <Select
                      value={bPartner.QryGroup7 || ''}
                      inputProps={{
                        name: 'QryGroup7',
                        onChange: handleChange,
                      }}
                    >
                      <MenuItem value="Y">Si</MenuItem>
                      <MenuItem value="N">No</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Facturación concepto proveedores</InputLabel>
                    <Select
                      value={bPartner.QryGroup8 || ''}
                      inputProps={{
                        name: 'QryGroup8',
                        onChange: handleChange,
                      }}
                    >
                      <MenuItem value="Y">Si</MenuItem>
                      <MenuItem value="N">No</MenuItem>
                    </Select>
                  </FormControl>
                </>
              ) : (
                <>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Proveedor de mercadería</InputLabel>
                    <Select
                      value={bPartner.QryGroup1 || ''}
                      inputProps={{
                        name: 'QryGroup1',
                        onChange: handleChange,
                      }}
                    >
                      <MenuItem value="Y">Si</MenuItem>
                      <MenuItem value="N">No</MenuItem>
                    </Select>
                  </FormControl>

                  {bPartner.QryGroup1 === 'N' ? undefined : (
                    <>
                      <TextField
                        label="Prefijo"
                        type="text"
                        name="prefix"
                        value={bPartner.prefix || ''}
                        margin="normal"
                        size="small"
                        inputProps={{
                          minLength: 3,
                          maxLength: 3,
                          onChange: handleChange,
                        }}
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <FormControl fullWidth margin="normal" size="small">
                        <InputLabel>Reconocimiento Desc.</InputLabel>
                        <Select
                          value={bPartner.QryGroup2 || ''}
                          inputProps={{
                            name: 'QryGroup2',
                            onChange: handleChange,
                          }}
                        >
                          <MenuItem value="Y">Si</MenuItem>
                          <MenuItem value="N">No</MenuItem>
                        </Select>
                      </FormControl>
                    </>
                  )}
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Proveedor de Vehículo</InputLabel>
                    <Select
                      value={bPartner.QryGroup3 || ''}
                      inputProps={{
                        name: 'QryGroup3',
                        onChange: handleChange,
                      }}
                    >
                      <MenuItem value="Y">Si</MenuItem>
                      <MenuItem value="N">No</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Proveedores varios</InputLabel>
                    <Select
                      value={bPartner.QryGroup7 || ''}
                      inputProps={{
                        name: 'QryGroup7',
                        onChange: handleChange,
                      }}
                    >
                      <MenuItem value="Y">Si</MenuItem>
                      <MenuItem value="N">No</MenuItem>
                    </Select>
                  </FormControl>
                </>
              )}

              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Recibo por honorarios</InputLabel>
                <Select
                  value={bPartner.QryGroup6 || ''}
                  inputProps={{
                    name: 'QryGroup6',
                    onChange: handleChange,
                  }}
                >
                  <MenuItem value="Y">Si</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Proveedor Principal</InputLabel>
                <Select
                  value={bPartner.QryGroup9 || ''}
                  inputProps={{
                    name: 'QryGroup9',
                    onChange: handleChange,
                  }}
                >
                  <MenuItem value="Y">Si</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
              </FormControl>
            </Paper>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={4}>
            <Paper className={classes.paper}>
              {/* <TextField
                label="Grupo Socio Negocio"
                name="GroupCode"
                value={bPartner.GroupCode}
                margin="normal"
                size="small"
                inputProps={{ onChange: handleChange }}
                fullWidth
                disabled
              /> */}
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Tipo Moneda</InputLabel>
                <Select
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  value={bPartner.base_currency_id || ''}
                  inputProps={{
                    name: 'base_currency_id',
                    onChange: handleChange,
                  }}
                >
                  {currencys.map((currency, i) => {
                    return (
                      <MenuItem value={currency.id} key={i}>
                        {currency.CurrCode}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Nuevo</InputLabel>
                <Select
                  value={bPartner.new || ''}
                  inputProps={{
                    name: 'new',
                    onChange: handleChange,
                  }}
                >
                  <MenuItem value="Y">Si</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Fecha de alta"
                type="date"
                name="start_date"
                value={bPartner.start_date || ''}
                margin="normal"
                size="small"
                inputProps={{ onChange: handleChange }}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
              {/* <TextField
                label="Fecha de baja"
                type="date"
                name="end_date"
                value={bPartner.end_date}
                margin="normal"
                size="small"
                inputProps={{ onChange: handleChange }}
                fullWidth
                disabled
                InputLabelProps={{
                  shrink: true
                }}
              /> */}
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Acreedor transportista</InputLabel>
                <Select
                  value={bPartner.U_SYP_BPAT || 'N'}
                  required
                  inputProps={{
                    name: 'U_SYP_BPAT',
                    onChange: handleChange,
                  }}
                >
                  <MenuItem value="Y">Si</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Sujeto a retención / detracción </InputLabel>
                <Select
                  value={bPartner.WTLiable || 'N'}
                  required
                  inputProps={{
                    name: 'WTLiable',
                    onChange: handleChange,
                  }}
                >
                  <MenuItem value="Y">Si</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Estado</InputLabel>
                <Select
                  value={bPartner.frozenFor || ''}
                  inputProps={{
                    name: 'frozenFor',
                    onChange: handleChange,
                  }}
                >
                  <MenuItem value="N">Activo</MenuItem>
                  <MenuItem value="Y">Inactivo</MenuItem>
                </Select>
              </FormControl>
              {bPartner.CardType === 'C' ? undefined : (
                <FormControl fullWidth margin="normal" size="small">
                  <InputLabel>Evaluación cód. compras</InputLabel>
                  <Select
                    value={bPartner.item_frgn || '1'}
                    inputProps={{
                      name: 'item_frgn',
                      onChange: handleChange,
                    }}
                  >
                    <MenuItem value="1">Código externo 1</MenuItem>
                    <MenuItem value="2">Código externo 2</MenuItem>
                  </Select>
                </FormControl>
              )}
              <TextField
                label="Comentario"
                name="Free_Text"
                value={bPartner.Free_Text || ''}
                margin="normal"
                size="small"
                inputProps={{ onChange: handleChange }}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Paper>
          </GridItem>

          {bPartner.CardType === 'P' ||
            (bPartner.QryGroup1 === 'Y' && (
              <GridItem xs={12} sm={6} md={6} lg={4}>
                <h4>Compras</h4>
                <Paper className={classes.paper}>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>No considerar bonificaciónes en último precio compra</InputLabel>
                    <Select
                      value={bPartner.QryGroup6 || 'N'}
                      required
                      inputProps={{
                        name: 'QryGroup6',
                        onChange: handleChange,
                      }}
                    >
                      <MenuItem value="Y">Si</MenuItem>
                      <MenuItem value="N">No</MenuItem>
                    </Select>
                  </FormControl>
                </Paper>

                <h4>Promociones</h4>
                <Paper className={classes.paper}>
                  <TextField
                    type="number"
                    label="Validación de bonifcaciones"
                    name="prom_bonification_validation"
                    value={bPartner.prom_bonification_validation || 0}
                    margin="normal"
                    size="small"
                    inputProps={{
                      onChange: handleChange,
                      min: 0,
                      max: 1000,
                    }}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Paper>

                <h4>Precio Mayorista</h4>
                <Paper className={classes.paper}>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel>Bloqueo de precio mayorista por portafolio</InputLabel>
                    <Select
                      value={bPartner.QryGroup10 || 'N'}
                      required
                      inputProps={{
                        name: 'QryGroup10',
                        onChange: handleChange,
                      }}
                    >
                      <MenuItem value="Y">Si</MenuItem>
                      <MenuItem value="N">No</MenuItem>
                    </Select>
                  </FormControl>
                </Paper>
              </GridItem>
            ))}
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
}
